import useServices from '../models/useServices'
import ServiceForm, { ServiceFormData } from './ServiceForm'
import { getHost } from '../utilities/service'
import { SERVICE_FORBIDDEN, toolRefusalMessage } from '../utilities/routerWrites'

interface Props {
  service: Service
  nodeId: string
  nodeName?: string
  onSuccess?: () => void
}

export default function EditService({ service, nodeId, nodeName, onSuccess }: Readonly<Props>) {
  const edit = useServices(s => s.edit)
  const deleteService = useServices(s => s.delete)
  const serviceType = service.url ? 'web' : 'terminal'
  const serviceUrl = `https://${getHost(service)}`

  // ⚠ The form closes only when the write landed. A refusal stays on screen as one sentence.
  const handleSave = async (data: ServiceFormData): Promise<string | null> => {
    try {
      await edit(service, data)
    } catch (e) {
      console.error('service_update failed:', e)
      return toolRefusalMessage(e, SERVICE_FORBIDDEN, 'Could not save the service.')
    }
    onSuccess?.()
    return null
  }

  const handleDelete = async (): Promise<string | null> => {
    try {
      await deleteService(service.id)
    } catch (e) {
      console.error('service_delete failed:', e)
      return toolRefusalMessage(e, SERVICE_FORBIDDEN, 'Could not delete the service.')
    }
    onSuccess?.()
    return null
  }

  return (
    <ServiceForm
      nodeId={nodeId}
      nodeName={nodeName}
      title="Edit Service"
      serviceType={serviceType}
      hideTypeChange={true}
      serviceUrl={serviceUrl}
      initialData={{
        title: service.title,
        url: service.url,
        command: service.command,
        admin: service.admin,
        workdir: service.workdir,
        authRequired: service.authRequired,
      }}
      actionButton={{
        label: 'Save',
        onClick: handleSave,
      }}
      onDelete={handleDelete}
      onCancel={() => onSuccess?.()}
    />
  )
}
